import * as levelConst from "./constants";
import transform from "./transform";
import _ from "lodash";
import { EVENT_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import { makeCall } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";

export const state = {
  levels: []
};

export const getters = {
  [levelConst.GETTERS_LIST_LEVEL]: state => {
    return _.orderBy(state.levels, ["LevelOrder", "Name"], ["asc", "asc"]);
  }
};

export const actions = {
  [levelConst.ACTIONS_SET_LEVEL_LIST]: ({ commit }, list) => {
    commit(
      levelConst.MUTATIONS_SET_LEVEL_LIST,
      transform.convertListLevelModel(list)
    );
  },
  [levelConst.ACTIONS_SET_LEVEL_LIST_PURE]: ({ commit }, list) => {
    commit(levelConst.MUTATIONS_SET_LEVEL_LIST, list);
  },
  [levelConst.ACTION_SET_PROGRAM_LEVELS]: ({ commit }, options) => {
    let rawProgramLevels = transform.convertListRawLevelModel(
      options.data.programLevelDTOs
    );
    options.data.programLevelDTOs = rawProgramLevels;
    const url = getEndPoints().programs.updateLevels.replace(
      ":id",
      options.programId
    );
    makeCall(url, buildOptions("POST", options.data), commit).then(response => {
      if (response) {
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        if (options.callback) {
          options.callback();
        }
      }
    });
  }
};

export const mutations = {
  [levelConst.MUTATIONS_SET_LEVEL_LIST]: (state, levels) => {
    state.levels = levels;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_levels/index.js